import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, Router} from '@angular/router';
import {ConfigService} from './config.service';
import {DataStorageService} from "./data-storage.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {ApiTextService} from "./apiServices/text/text.service";
import {SecurityService} from "./security.service";
import {PricingService} from "./pricing.service";
import {ApiService} from "./api.service";
import { environment } from '../environments/environment';

@Injectable()
export class AuthLogin implements CanActivate {


  constructor(private config: ConfigService,
              public dataStorageService: DataStorageService,
              private http: HttpClient,
              private route: ActivatedRoute,
              //  public securityService: SecurityService,
              private tApi: ApiTextService,
              public router: Router,
              public securityService: SecurityService,
              private configService: ConfigService,
              private pricing: PricingService,
              private api: ApiService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
   // console.log('boubii', route.queryParams);
    if(!environment.production) {
      var partnerId = localStorage.getItem('partnerId')
      var user = localStorage.getItem('user')
      if(partnerId && user) {
        this.router.navigate(['/disclaimer']);
        return true;
      }
    }
   
    
    if (localStorage.getItem('partnerId') && route.queryParams.user) {
      localStorage.setItem('user', route.queryParams.user);
      this.router.navigate(['/disclaimer']);
     // this.getToken(route.queryParams.user, localStorage.getItem('partnerId').toString());
    }  else if (route.queryParams.partnerId) {
      localStorage.setItem('partnerId', route.queryParams.partnerId);
      this.authRedirect();
    } else {
      alert('Please go connect to portal.peoplefone.ch first !');
       window.location.href = 'https://portal.peoplefone.ch';
    }
    return true;
  }


  authRedirect() {

    const possible = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lengthOfCode = 40;
    // tslint:disable-next-line:prefer-const
    const state = this.makeRandom(lengthOfCode, possible);
    window.location.href = this.config.oauthUrl + '/oauth/authorize?client_id=' + this.config.clien_id + '&locale=en_CH&redirect_uri=' + this.config.authbackUrl + '&response_type=code&scope=&state=' + state;
    return true;

  }

  getToken(code, partnerId) {

    this.dataStorageService.invalidCredentials = '';
    this.securityService.getTokenWithCode(code, partnerId)
      .then(() => {
        this.tApi.getAllUITexts().then(res => this.dataStorageService.uiText = res);
        this.api.getCategories();
        this.api.getGlobalCategories();
        this.pricing.getPPHostedNodesPricelist().then(res => this.dataStorageService.nodesPricingPPhosted = res);
        if (this.securityService.isAdmin() && (!this.securityService.isUser() || !this.securityService.isLeader())) {
          this.router.navigate(['/management']);
        } else if (this.securityService.isUser() || this.securityService.isLeader()) {
          this.router.navigate(['/disclaimer']);
          // setTimeout(() => this.router.navigate(['/disclaimer']), 500);
          console.log('ok');
        }
      }).catch(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        this.dataStorageService.invalidCredentials = 'Invalid Credentials';
      }
      alert('403 Forbidden oauth connect');
      window.location.href = 'https://portal.peoplefone.ch';

      // this.securityService.logout();
    });
  }

  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
}






// WEBPACK FOOTER //
// ./src/app/authLogin.ts